import { asTeammateId } from "@repo/app-types/entities/teammate";
import { isStaticTeammateAgentIdentity } from "@repo/app-types/entities/teammateAgent";
import type { FC } from "react";
import { Navigate, useParams } from "react-router";
import { useGetTeammateAgentQuery } from "../../api/entities/teammateAgent.js";
import { useFunnelView } from "./funnel/useFunnelView.js";

/**
 * Where an agent's page opens: the Performance tab's Funnel view when it's
 * shown and the agent has a funnel, otherwise its Analytics view. Waits for
 * the agent and its funnels so it redirects once.
 */
export const TeammateAgentDefaultView: FC = () => {
  const { teammateAgentId: teammateAgentIdParam } = useParams();
  if (!teammateAgentIdParam) {
    throw new Error("Missing teammateAgentId param.");
  }
  const teammateAgentId = asTeammateId(teammateAgentIdParam);
  const { data: teammateAgent } = useGetTeammateAgentQuery(teammateAgentId);
  const funnelView = useFunnelView(
    teammateAgentId,
    teammateAgent !== undefined &&
      isStaticTeammateAgentIdentity(
        teammateAgent.teammate_agent_config.identity,
      ),
  );

  if (!teammateAgent || funnelView.isLoading) {
    return null;
  }
  return <Navigate to={funnelView.isDefault ? "funnel" : "overview"} replace />;
};
